import { memo } from 'react';
import cn from 'classnames';
import { useAsync } from 'react-use';
import { ArrayUtils, StringUtils } from 'src/utils';
import { CommonService } from 'src/services';
import { Element } from 'src/components';
import RouterLink from 'src/components/links';
import { IExchangeRate, IExchangeRateEntry } from '@zmedia/bm-common/modules';

export function ExchangeBox() {
    const state = useAsync(CommonService.getCurrencyList);
    const data = state.value?.data || {};
    const boards: IExchangeRate[] = data?.boards || [];

    if (ArrayUtils.isEmpty(boards)) {
        return null;
    }
    const info = boards[0]?.lastUpdateTime.split(' ');

    const usd = boards[0]?.entries?.filter(
        (item: IExchangeRateEntry) => item.code === 'USD',
    );

    return (
        <RouterLink
            to="/tien-ich-ty-gia-ngoai-te.epi"
            className={cn(
                'relative',
                'border-[rgba(9,111,250,0.1)] border border-solid',
                'rounded-[4px]',
                'w-[210px]',
                "bg-[url('https://baomoi-static.bmcdn.me/web/styles/img/money-bg.png')]",
                'bg-cover',
                'bg-center',
                'px-[16px] pt-[18px] pb-[6px]',
                'block',
                'shrink-0'
            )}
        >
            <Element className="flex justify-between">
                <Element className="text-[#0050C7] text-[10px] font-[800] leading-[1.6]">
                    Tỷ giá
                    <Element className="text-[#1A1A1A] text-[18px] font-[900] leading-[1.2]">
                        USD
                    </Element>
                </Element>
                <Element
                    className={cn(
                        'flex items-center flex-col',
                        'text-[rgba(0,0,0,0.6)]',
                    )}
                >
                    {usd && (
                        <>
                            <Element className="text-[13px] flex whitespace-nowrap">
                                <Element className="font-bold">
                                    Mua:&nbsp;
                                </Element>
                                <Element className="font-[900] text-[#131214]">
                                    {StringUtils.numberWithCommas(
                                        usd[0].buyTransfer,
                                    )}
                                </Element>
                            </Element>
                            <Element className="text-[13px] flex whitespace-nowrap mt-[3px]">
                                <Element className="font-bold">
                                    Bán:&nbsp;
                                </Element>
                                <Element className="font-[900] text-[#131214]">
                                    {StringUtils.numberWithCommas(
                                        usd[0].sellCash,
                                    )}
                                </Element>
                            </Element>
                        </>
                    )}
                </Element>
            </Element>
            <Element className="text-right text-[8px] text-[#666] mt-[2px]">
                *Nguồn Vietcombank, {info[1].replace(/:/g, 'h')} ngày{' '}
                {info[0].replace(/-/g, '/')}
            </Element>
        </RouterLink>
    );
}

export default memo(ExchangeBox);
